import { BannerSlider } from "@omni/components/components/BannerSlider/bannerSlider";
import { cn } from "@omni/utils/styles";

export const BannerSliderComponent = () => {
    return (
        <>
            <BannerSlider.Slider>
                <BannerSlider.Slider.NavButton
                    type={"left"}
                    className={cn(
                        "tw:hidden tw:md:block tw:absolute tw:left-0 tw:top-1/2 tw:bg-background tw:translate-y-[-50%] tw:layer-base/[2] tw:px-1 tw:opacity-100!"
                    )}
                />
                <BannerSlider.Slider.Slides className={cn("tw:mb-4")}>
                    <BannerSlider.Slider.Slides.Slide />
                </BannerSlider.Slider.Slides>
                <BannerSlider.Slider.NavButton
                    type={"right"}
                    className={cn(
                        "tw:hidden tw:md:block tw:absolute tw:right-0 tw:top-1/2 tw:bg-background tw:translate-y-[-50%] tw:layer-base/[2] tw:px-1 tw:opacity-100!"
                    )}
                />
            </BannerSlider.Slider>
            <BannerSlider.Controls>
                <BannerSlider.Controls.ProgressBar>
                    <BannerSlider.Controls.ProgressBar.Bar>
                        <BannerSlider.Controls.ProgressBar.Bar.Content />
                    </BannerSlider.Controls.ProgressBar.Bar>
                </BannerSlider.Controls.ProgressBar>
                <BannerSlider.Controls.Button />
            </BannerSlider.Controls>
        </>
    );
};
